import { defineStore } from 'pinia'

export const useThemeStore = defineStore('theme', {
    state: () => ({
        currentTheme: 'dark', // 'light' or 'dark'
    }),

    getters: {
        isDarkTheme: (state) => state.currentTheme === 'dark',
        isLightTheme: (state) => state.currentTheme === 'light',
    },

    actions: {
        setTheme(themeName) {
            this.currentTheme = themeName
            this.applyTheme(themeName)
            this.saveThemePreference(themeName)
        },

        toggleTheme() {
            const newTheme = this.currentTheme === 'dark' ? 'light' : 'dark'
            this.setTheme(newTheme)
        },

        applyTheme(themeName) {
            if (themeName === 'light') {
                document.documentElement.setAttribute('data-theme', 'light')
            } else {
                // default (dark) falls back to :root variables
                document.documentElement.removeAttribute('data-theme')
            }
        },

        saveThemePreference(themeName) {
            try {
                localStorage.setItem('theme-preference', themeName)
            } catch (e) {
                console.warn('Unable to save theme preference', e)
            }
        },

        loadThemePreference() {
            try {
                const saved = localStorage.getItem('theme-preference')
                if (saved) {
                    this.setTheme(saved)
                    return true
                }
            } catch (e) {
                console.warn('Unable to read theme preference', e)
            }
            return false
        },

        initializeTheme() {
            // Try to load saved preference
            if (this.loadThemePreference()) {
                return
            }

            // Otherwise, use system preference
            const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches
            this.setTheme(prefersDark ? 'dark' : 'light')
        }
    }
})
